"use client";

import { useSearchMessages } from "@/i18n/hooks/useSearchMessages";
import { getFacetAttributeName } from "./getFacetAttributeName";

interface LearningTypeSubtitleProps {
  filterCategory: string;
  itemValue: string;
  indexName: string;
  className?: string;
}

export default function LearningTypeSubtitle({
  filterCategory,
  itemValue,
  indexName,
  className = "text-xs text-gray-700",
}: LearningTypeSubtitleProps) {
  const { getLearningTypeSubtitle } = useSearchMessages();
  const learningTypeFacet = getFacetAttributeName("learning_type", {
    indexName,
  });

  const subtitle = getLearningTypeSubtitle(itemValue);

  if (filterCategory !== learningTypeFacet || !subtitle) {
    return null;
  }

  return <label className={className}>{subtitle}</label>;
}
